import React, { useState, useEffect } from "react";
import * as ReactIcons from "react-icons/fa";
import "./style.css";
import { IconContext } from "react-icons";
import {
  serviceHeader,
  sofaCleaning,
  acRepairs,
  banner,
  logo,
  painting,
} from "../../assets/images";
import OfferCard from "../../components/offerCards";
import Modal from "../../components/modal/index";
import AboutUs from "../../components/modal/AboutUs/index";
import { useMediaQuery } from "react-responsive";
import { Link, useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import MenuModal from "../../components/menu";



const categories = [
  { id: 1, name: "Painting", icon: "FaBrush" },
  { id: 2, name: "Cleaning", icon: "FaBroom" },
  { id: 3, name: "Bathroom Cleaning", icon: "FaShower" },
  { id: 4, name: "Sofa Cleaning", icon: "FaCouch" },
  { id: 5, name: "AC Repairs", icon: "FaSnowflake" },
  { id: 6, name: "Carpenter Services", icon: "FaHammer" },
  { id: 7, name: "Plumbing", icon: "FaFaucet" },
  { id: 8, name: "Electrician", icon: "FaPlug" },
];

const offerProducts = [
  {
    id: 1,
    desc: "Sofa cleaning at just 299/-",
    img: sofaCleaning,
    category: "Sofa Cleaning",
  },
  {
    id: 2,
    desc: "Hassle-free AC repairs  ",
    img: acRepairs,
    category: "AC Repairs",
  },
  {
    id: 3,
    desc: "Painting starts at just @ ₹5/sq.ft",
    img: painting,
    category: "Painting",
  },
];

const LandingPage = () => {
  const [selectedCategory, setSelectedCategory] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [aboutUs, setAboutUs] = useState(false);
  const [user, setUser] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  const isDesktopOrPhone = useMediaQuery({ maxWidth: 600 });
  const iconSize = isDesktopOrPhone ? 30 : 60;

  useEffect(() => {
    setSelectedCategory("");
  }, []);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (authUser) => {
      setUser(authUser);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  const handleViewOrders = () => {
    // Navigate to the orders page ("/orders")
    navigate('/orders');
  };

  const handleLogout = () => {
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        // User successfully signed out
        setUser(null);
        setIsModalOpen(false);
      })
      .catch((error) => {
        // Handle sign-out errors
        console.error('Sign-out error:', error.message);
      });
  };

  const handleCategoryClick = (categoryName) => {
    setSelectedCategory(categoryName);
    setIsModalVisible(true);
    // Show the modal with the enquiry form
    // Implement your logic here to display the modal
  };

  return (
    <div className="Container-window">
      <header>
        {/* Header banner image carousel */}
        <div className="banner-carousel">
          {/* Place your banner carousel code here */}
          <div className="action-header">
            <div className="logo-container">
              <img
                src={logo}
                alt="Metro Home Services"
                className="logo-image"
              />
            </div>
            {/* <div className="auth-gateway" style={{backgroundColor: '#090173', borderRadius:6}}>
              <Link
                to="/auth/login"
                style={{ textDecoration: "none", color: '#FFF' }}
              >
                Login / Register
              </Link>
            </div> */}
             {user ? (
            // User is logged in, show Logout button
            <div className="auth-gateway" style={{ backgroundColor: '#090173', borderRadius: 6 }}>
            <button onClick={() => setIsModalOpen(true)} style={{ color: '#FFF', background: 'none', border: 'none', cursor: 'pointer' }}>
              Menu
            </button>
          </div>
          ) : (
            // User is not logged in, show Login / Register button
            <div className="auth-gateway" style={{ backgroundColor: '#090173', borderRadius: 6 }}>
              <Link
                to="/auth/login"
                style={{ textDecoration: "none", color: '#FFF' }}
              >
                Login / Register
              </Link>
            </div>
          )}
          </div>
          <img
            src={banner}
            alt="Image by pressfoto on Freepik"
            style={{ width: "100%", height: "100%", marginTop: "-8%" }}
            className="banner-image"
          />
        </div>
      </header>

      {/* category section */}
      <section className="category-section">
  <div className="category-main">
    {/* Category boxes */}
    <div className="category-row">
      {categories.slice(0, 4).map((category) => {
        const IconComponent = ReactIcons[category.icon];
        return (
          <div
            className={`category-box ${
              selectedCategory === category.name ? "active" : ""
            }`}
            onClick={() => handleCategoryClick(category.name)}
            key={category.name}
          >
            <div className="category-icon-container">
              <IconContext.Provider
                value={{
                  color: "#011f94",
                  size: iconSize,
                }}
              >
                <IconComponent />
              </IconContext.Provider>
            </div>
            <div className="category-label-container">
              <p className="category-label">{category.name}</p>
            </div>
          </div>
        );
      })}
    </div>
    <div className="category-row">
      {categories.slice(4, 8).map((category, index) => {
        const IconComponent = ReactIcons[category.icon];
        const isDisabled = index >= 0; // Disable categories from index 1 onwards
        return (
          <div
            className={`category-box ${
              selectedCategory === category.name ? "active" : ""
            } ${isDisabled ? "disabled" : ""}`} // Add "disabled" class if the category is disabled
            onClick={() => !isDisabled && handleCategoryClick(category.name)} // Disable onClick if category is disabled
            key={category.name}
          >
            <div className="category-icon-container">
              <IconContext.Provider
                value={{ color: isDisabled ? "#ccc" : "#011f94", size: iconSize }} // Change color to gray if disabled
              >
                <IconComponent />
              </IconContext.Provider>
            </div>
            <div className="category-label-container">
              <span className="category-label">{category.name}</span>
            </div>
          </div>
        );
      })}
    </div>
  </div>
</section>


      {/* offer section */}
      <section className="offer-zone">
        <div className="section-header">
          <p className="section-header-text">Offers For You</p>
          <div className="lineBreak" />
        </div>

        <div className="offer-container">
          {offerProducts.map((offer) => {
            return (
              <OfferCard
                descText={offer.desc}
                backgroundImg={offer.img}
                setCategory={() => {
                  setSelectedCategory(offer?.category);
                  setIsModalVisible(true);
                }}
                // buttonStyle={{}}
              />
            );
          })}
        </div>
      </section>

      <section className="offer-zone">
        <div className="section-header">
          <p className="section-header-text">Popular services</p>
          <div className="lineBreak" />
        </div>

        <div className="offer-container">
          {offerProducts.map((offer) => {
            return (
              <OfferCard
                descText={offer.desc}
                backgroundImg={offer.img}
                setCategory={() => {
                  setSelectedCategory(offer?.category);
                  setIsModalVisible(true);
                }}
              />
            );
          })}
        </div>
      </section>

      {/* modal for forms */}
      {isModalVisible ? (
        <Modal
          selectedCategory={selectedCategory}
          closeModal={() => setIsModalVisible(false)}
        />
      ) : null}
      {aboutUs ? <AboutUs closeModal={() => setAboutUs(false)} /> : null}

      {isModalOpen ? <MenuModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onLogout={handleLogout}
        onViewOrders={handleViewOrders}
      /> : null}

      {/* Modal with enquiry form */}
      {/* Implement your modal code here */}

      <footer className="footer-main">
        {/* Footer section */}
        <div className="footer-container">
          <div className="left-section">
            <img src={logo} alt="Company Logo" className="logo-footer" />
          </div>
          <div className="right-section">
            <div className="about-us" onClick={() => setAboutUs(true)}>
              About Us
            </div>
            <div className="footer-address">
              <p>
                METRO HOME SERVICES, 4th Floor, <br />
                BENAKA RESIDENCY, HSR 7th SECTOR, <br />
                Behind TOTAL ENERGIES,
                <br />
                BENGALURU, 560068.
                <br />
                Call us at : +91-6364238679
              </p>
            </div>
          </div>
        </div>
        <div className="footer-span">
          <span>© 2023 Metro Home Services Pvt. Ltd.</span>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
